export type PoolCardInfoProps = {
  title: string;
  value?: number | string | null;
  placeholder?: string;
};

export default function PoolCardInfo({ title, value, placeholder = '--' }: PoolCardInfoProps) {
  return (
    <div className="flex flex-col gap-0.5">
      <div className="text-[#B2B2B2] text-sm font-medium font-avenir">{title}</div>
      <div className="text-black text-base font-medium font-avenir">{value ?? placeholder}</div>
    </div>
  );
}
